import type { CatalogueEntry } from "../types";
import imageLight from "../images/address-pool.light.webp";
import imageDark from "../images/address-pool.dark.webp";

export const entry: CatalogueEntry = {
  slug: "address-pool",
  displayName: `Address Pool`,
  datasetProductCode: `ADDRESS-POOL`,
  subtitle: `Swimming Pool Presence, Count and Area by Address`,
  shortDescription: `The Address Pool Insight Pack is a national digital dataset providing swimming pool information at the address level across all Australian states and territories. It includes a pool presence flag, pool count and pool area.
Address Pool links to the National Buildings product through the address_pid, and to G-NAF through the address_detail_pid, so pool insights can be joined to buildings and addresses across Australia.`,
  metadata: {
    dateAdded: 1787270400000,
    dataType: ["Aspatial"],
    totalFeatureCount: 13927823,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/address_pool_insight_pack/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/address_pool_insight_pack/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `Address Pool National Buildings G-NAF Insight Pack Swimming Pool Pool Presence Pool Count Pool Area Safety Compliance Insurance Council Rates Property Insights Aerial Imagery Geoscape Address Pool`,
  detail: () => import("../details/address-pool").then((m) => m.detail),
};

export default entry;
